import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ItemOfficeSpace from "./ItemOfficeSpace";
import VisitModal from "./VisitModal";
import {
  filterPropertyList,
  getImageUrl,
  sendWebhookAPI,
  sendWebhookAPI2,
} from "../../services/apiServices";
import { setToken } from "../../utils/axiosClient";
import { usePropertyStore } from "../../redux/features/propertyDetailSlice";
import { useAuthStore } from "../../redux/features/authSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "../common/Loader";
import { ClipLoader } from "react-spinners";
import { useRedirectStore } from "../../redux/features/userRedirectSlice";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  formatVisitMessage,
  generateMessage,
} from "../../utils/common-function";
import AppointmentRequest from "./AppointmentRequest";
import Modal, { useComponent } from "../common/Modal";
import SignIn from "../auth/SignIn";
import { useTranslation } from "react-i18next";

const OfficeSpace = () => {
  const navigate = useNavigate();
  const { loginInfo, removeLoginInfo, isLoggedin } = useAuthStore();
  const { userRedirectFlag, updateUserRedirectState } = useRedirectStore();
  const { propertyInfo, updatePropertyInfo } = usePropertyStore();
  const [resultCount, setResultCount] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedISOCode, setSelectedISOICode] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [render, setRender] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [appointmentModel, appointmentModelSet] = useState(false);
  const [isVisitSelected, setIsVisitSelected] = useState(true);
  const toggleVisitModal = () => {
    setIsOpen(!isOpen);
  };
  const cancelToSendTimeSlot = () => {
    setSelectedItems([]);
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const index = searchParams.get("index");
  const onSearchResults = async () => {
    try {
      if (!hasMore || loading) return;
      // Check if suggestions array contains a location
      setToken(loginInfo ? loginInfo?.token : null);
      setLoading(true);
      let payload = {};

      payload = {
        page: page,
        limit: 20,
        location: {
          latLng: {
            latitude:
              index >= 0 ? propertyInfo?.location?.latLng?.latitude : "",
            longitude:
              index >= 0 ? propertyInfo?.location?.latLng?.longitude : "",
          },
          address: index >= 0 ? propertyInfo?.location?.address : "",
        },
        calculatedSize:
          index >= 0
            ? propertyInfo?.calculatedSize?.size?.length > 0
              ? propertyInfo?.calculatedSize?.size
              : [0, 0]
            : "",
        // isFurnished:
        //   index >= 1
        //     ? propertyInfo?.furnished?.answer
        //       ? propertyInfo?.furnished?.answer
        //       : ""
        //     : "",

        movePlan:
          index >= 1
            ? propertyInfo?.movePlan?.answer
              ? propertyInfo?.movePlan?.answer
              : ""
            : "",

        monthlyBudget:
          index >= 2
            ? propertyInfo?.budgetPricing?.answer
              ? propertyInfo?.budgetPricing?.answer
              : ""
            : "",

        preferredLocation:
          index >= 3
            ? propertyInfo?.preferredLocation
              ? propertyInfo?.preferredLocation
              : ""
            : "",

        officeType:
          index >= 4
            ? propertyInfo?.officeType?.answer
              ? propertyInfo?.officeType?.answer
              : ""
            : "",

        leaseTermsDuration:
          index >= 5
            ? propertyInfo?.leaseDuration?.answer
              ? propertyInfo?.leaseDuration?.answer
              : ""
            : "",

        // officeSpaces:
        //   index >= 6
        //     ? propertyInfo?.officeSpaces?.answer
        //       ? propertyInfo?.officeSpaces?.answer
        //       : ""
        //     : "",

        parking:
          index >= 6
            ? propertyInfo?.parking?.answer
              ? propertyInfo?.parking?.answer
              : ""
            : "",
        type: "pagination",
      };
      const response = await filterPropertyList(payload);
      if (response?.data?.statusCode == 200) {
        // setPropertyData(response?.data?.data);
        // setPropertyData((prev) => [...prev, ...response?.data?.data]);
        // Filter out duplicate entries
        setPropertyData((prev) => {
          const uniqueProperties = [...prev, ...response?.data?.data].reduce(
            (acc, item) => {
              if (!acc.some((existing) => existing.id === item.id)) {
                acc.push(item);
              }
              return acc;
            },
            []
          );
          return uniqueProperties;
        });

        if (page >= response.data.totalPages) {
          setHasMore(false);
        } else {
          setPage((prev) => prev + 1);
        }

        setResultCount(response?.data?.count);
      } else if (response?.data?.statusCode == 401) {
        toast.warning(
          response?.data?.message || "Your session has been expired.",
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        updateUserRedirectState();
        removeLoginInfo();
        navigate("/");
      } else {
        console.warn(
          "error coming in filter property listing in API gives 401"
        );
      }
    } catch (error) {
      console.warn("error coming in filter property list: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onSearchResults();
  }, []);

  const sendWebhookData = async () => {
    if (!isLoggedin) {
      setIsModalOpen(true);

      // toast.warning("You need to log in to continue.", {
      //   position: "top-right",
      //   autoClose: 3000,
      // });
    }
    if (isLoggedin) {
      const countryCodes = [...new Set(selectedISOCode)];
      setLoading(true);
      try {
        const payload = {
          fullName: loginInfo?.user?.fullname,
          lastName: "",
          email: loginInfo?.user?.email,
          phoneNumber: loginInfo?.user?.phone,
          companyName: loginInfo?.user?.companyName,
          sizeMin: propertyInfo?.calculatedSize?.size[0],
          sizeMax: propertyInfo?.calculatedSize?.size[1],
          message: "",
          countryCode: `ISO Code of the country where they are searching: ${countryCodes}`,
          selectedProperties: selectedItems,
        };
        const message = generateMessage(propertyInfo, loginInfo);

        await sendWebhookAPI2({
          email: loginInfo?.user?.email,
          full_name: loginInfo?.user?.fullname,
          phone_number: loginInfo?.user?.phone,
          space: propertyInfo?.calculatedSize.sizeCount,
          city: "Bucharest",
          body: message,
          properties: selectedItems,
        });
        const response = await sendWebhookAPI(payload);
        if (response?.data?.statusCode == 200) {
          toast.success(
            "Your request was sent successfully. You will be contacted by the leasing representstives soon.",
            {
              position: "top-right",
              autoClose: 3000,
            }
          );
          cancelToSendTimeSlot();
          appointmentModelSet(true);
          setIsVisitSelected(false);
        } else {
          console.warn("error coming in webhook in API gives 401");
        }
      } catch (error) {
        console.warn("Error coming in while sending request webhook:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const OnCloseFun = (setCurrentComponent, check) => {
    setIsModalOpen(false);
  };

  const { t } = useTranslation();
  return (
    <div>
      {/* <div className="col-span-12 md:col-span-8">
        <div className="overflow-y-scroll md:p-5 p-3 h-[400px]">
          {appointmentModel &&
            <AppointmentRequest
              // requestData={requestData}
              onClose={toggleVisitModal}
            />
          }
        </div>
      </div> */}

      <Modal
        isOpen={isModalOpen}
        onClose={(setCurrentComponent, check) =>
          OnCloseFun(setCurrentComponent, check)
        }
      ></Modal>
      <div className="container mx-auto max-w-4xl mt-14 relative">
        <div className="flex justify-between gap-3 items-center">
          <h2 className="md:text-3xl text-2xl font-bold">
            {t("office_space_available")}
          </h2>
          <p className="text-[#5D5D5D] text-lg font-semibold">
            {`${resultCount}`} {t("office_space_Results")}
          </p>
        </div>
        {loading && <Loader loading={loading} />}

        {/* {!loading && ( */}
        <InfiniteScroll
          dataLength={propertyData?.length}
          // next={page >= 1 ? onSearchResults : ""}Aviatorilor Business Plaza
          next={onSearchResults}
          hasMore={hasMore}
          loader={
            <h4 style={{ display: "flex", justifyContent: "center" }}>
              {t("office_space_loading")}...
            </h4>
          }
          endMessage={<p></p>}
        >
          <div className="flex flex-col md:gap-6 gap-3 mb-20 mt-5">
            {propertyData?.map((item, index) => (
              <ItemOfficeSpace
                address={`${
                  item?.address?.postal_code ? item?.address?.postal_code : ""
                } ${item?.address?.street ? item?.address?.street : ""} ${
                  item?.address?.district?.name
                    ? item?.address?.district?.name
                    : ""
                }`}
                title={item?.property_translation?.property_name}
                // price={
                //   item?.property_rent_info?.rent_fee_min
                //     ? `${item?.property_rent_info?.rent_fee_min} per sq meter`
                //     : ""
                // }
                price={
                  item?.property_rent_info?.rent_fee_min
                    ? `${item?.property_rent_info?.rent_fee_min} ${t(
                        "office_space_per_sq_meter"
                      )}`
                    : ""
                }
                // $45 per sq meter
                // area={
                //   item?.property_rent_info?.min_area_for_rent &&
                //     item?.property_rent_info?.area_for_rent
                //     ? `${item?.property_rent_info?.min_area_for_rent
                //       ? item?.property_rent_info?.min_area_for_rent
                //       : ""
                //     } - ${item?.property_rent_info?.area_for_rent
                //       ? item?.property_rent_info?.area_for_rent
                //       : ""
                //     } sq meter`
                //     : item?.property_rent_info?.min_area_for_rent
                //       ? `${item?.property_rent_info?.min_area_for_rent} sq meter`
                //       : ""
                // }

                area={
                  item?.property_rent_info?.min_area_for_rent &&
                  item?.property_rent_info?.area_for_rent
                    ? `${item.property_rent_info.min_area_for_rent} - ${
                        item.property_rent_info.area_for_rent
                      } ${t("office_space_sq_meter")}`
                    : item?.property_rent_info?.min_area_for_rent
                    ? `${item.property_rent_info.min_area_for_rent} ${t(
                        "office_space_sq_meter"
                      )}`
                    : ""
                }
                image={item?.imgUri}
                id={item.id}
                setSelectedItems={setSelectedItems}
                data={item}
                selectedItems={selectedItems}
                setSelectedISOICode={setSelectedISOICode}
                iso_code={item?.country?.iso_code}
              />
            ))}
          </div>
        </InfiniteScroll>
        {/* )} */}
      </div>
      {selectedItems.length > 0 && (
        <div
          className="flex gap-4 justify-center items-center fixed pt-10 pb-10 bottom-0 w-full"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)",
          }}
        >
          {/* <button
            className="text-[#5D5D5D] text-base font-semibold bg-white border border-[#C0C0C0] rounded-[48px] px-4 py-2"
            onClick={cancelToSendTimeSlot}
          >
            Cancel
          </button> */}

          <button
            // onClick={toggleVisitModal}
            onClick={sendWebhookData}
            className="text-white text-base font-semibold bg-red-600 border border-[#C0C0C0] rounded-[48px] px-4 py-2"
          >
            {t("office_space_visit")}
          </button>
        </div>
      )}

      <VisitModal
        isOpen={isOpen}
        onClose={toggleVisitModal}
        selectedItems={selectedItems}
        selectedISOCode={selectedISOCode}
      />
    </div>
  );
};

export default OfficeSpace;
